import { css } from '@emotion/react';

export const globalStyles = css`
  /* CSS Reset */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  body {
    width: 100%;
    height: 100%;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f5f5f5;
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  #root {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    font-weight: 400;
    margin: 0;
  }

  p {
    margin: 0;
  }

  /* Button Reset */
  button {
    background: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
    
    &:focus {
      outline: none;
    }
    
    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  /* Input Reset */
  input, select {
    border: none;
    outline: none;
    font-family: inherit;
    box-sizing: border-box;
    
    &:focus {
      outline: 2px solid #6A42F2;
      outline-offset: 2px;
    }
  }

  /* List Reset */
  ul, ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  /* Link Reset */
  a {
    text-decoration: none;
    color: inherit;
  }

  /* Image Reset */
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* Accessibility */
  *:focus-visible {
    outline: 2px solid #6A42F2;
    outline-offset: 2px;
  }

  /* Scrollbar Styling */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
    
    &:hover {
      background: #a8a8a8;
    }
  }

  /* Selection */
  ::selection {
    background-color: #6A42F2;
    color: white;
  }

  /* Firefox scrollbar */
  * {
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 #f1f1f1;
  }

  /* Color Variables (CSS Custom Properties) */
  :root {
    --primary-purple: #6A42F2;
    --danger-red: #FF4B4B;
    --success-green: #009444;
    --background-gray: #f5f5f5;
    --card-white: #ffffff;
    --text-dark: #333333;
    --text-medium: #666666;
    --text-light: rgba(255, 255, 255, 0.7);
    --sidebar-gradient-start: rgba(165, 80, 255, 1);
    --sidebar-gradient-end: rgba(118, 72, 200, 1);
    --shadow-light: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
    --border-light: rgba(255, 255, 255, 0.2);
    --border-gray: #dddddd;
    --nav-active: rgba(255, 255, 255, 0.25);
    --nav-hover: rgba(255, 255, 255, 0.15);
    --input-bg: #f9fafb;
  }

  /* Screen Reader Only */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  /* Loading Animation */
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .loading {
    animation: spin 1s linear infinite;
  }

  /* Fade Animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .fade-in {
    animation: fadeIn 0.3s ease-in-out;
  }

  /* Responsive Design Breakpoints */
  @media (max-width: 1920px) {
    /* Large desktop adjustments if needed */
  }

  @media (max-width: 1440px) {
    /* Medium desktop adjustments */
  }

  @media (max-width: 1024px) {
    /* Tablet adjustments */
  }

  @media (max-width: 768px) {
    /* Mobile adjustments */
  }

  @media (max-width: 480px) {
    /* Small mobile adjustments */
  }

  /* Print Styles */
  @media print {
    * {
      background: transparent !important;
      color: black !important;
      box-shadow: none !important;
      text-shadow: none !important;
    }
    
    a,
    a:visited {
      text-decoration: underline;
    }
    
    pre,
    blockquote {
      border: 1px solid #999;
      page-break-inside: avoid;
    }
    
    thead {
      display: table-header-group;
    }
    
    tr,
    img {
      page-break-inside: avoid;
    }
    
    img {
      max-width: 100% !important;
    }
    
    p,
    h2,
    h3 {
      orphans: 3;
      widows: 3;
    }
    
    h2,
    h3 {
      page-break-after: avoid;
    }
  }
`;